// Bloque N-mínimo, sesión 5 (docs/PLAN_BLOQUE_N.md): piezas puras del paso "Publicar" —
// separadas del componente para poder probarlas sin montar la UI, mismo patrón que
// offerWizardRule.ts.

/** Arma el cuerpo Markdown de un guion de llamada en el formato que ya lee
 * session/callScript.ts (parseSections: bloques "## Título\ntexto"). Solo 3 secciones
 * (el asistente no captura Motivo ni Objeciones todavía) — parseSections no exige que
 * estén las 5 de siempre. */
export const buildCallScriptMarkdown = (
  apertura: string,
  preguntas: string[],
  cierre: string,
): string =>
  [
    `## Apertura\n${apertura.trim()}`,
    preguntas.length
      ? `## Descubrimiento\n${preguntas.map((p) => `- ${p.trim()}`).join("\n")}`
      : "",
    `## Cierre\n${cierre.trim()}`,
  ]
    .filter(Boolean)
    .join("\n\n");
